import { useQuery } from "react-query";
import axios from "axios";

const useGet = (api_end_point, options = {}) => {
  const localData = JSON.parse(localStorage.getItem("local_data"));
  const { data, isLoading, error, refetch } = useQuery(
    ["data", api_end_point],
    async () => {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/${api_end_point}`,
        {
          headers: {
            // Authorization: `Bearer ${localData?.access_token}`,
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    },
    {
      refetchOnWindowFocus: false,
      ...options,
    }
  );

  return { data, isLoading, error, refetch };
};

export default useGet;
